export default __webpack_public_path__ + "static/media/User3.5e785a96.jpg";